module.exports = __webpack_public_path__ + "4f7648d2145e01fce9f163ab2698ccd3.pdf";